import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';

const SUPPORT_EMAIL = 'info@perfeasy.com';

const AccountDeletion = () => {
  const mailSubject = encodeURIComponent('BacchaPanti account deletion request');
  const mailBody = encodeURIComponent(
    'Please delete my BacchaPanti account and associated data.\n\nRegistered email:\nFull name:\nReason (optional):\n'
  );
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${mailSubject}&body=${mailBody}`;

  return (
    <Container maxWidth="md">
      <Box sx={{ minHeight: '100vh', py: 6 }}>
        <Paper sx={{ p: { xs: 3, sm: 5 } }} elevation={2}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Account deletion
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            BacchaPanti is the official mobile and web app for BacchaPanti team members. If you
            no longer need your account, you can request deletion of your account and associated
            personal data.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} gutterBottom>
            How to request deletion
          </Typography>
          <List dense sx={{ listStyleType: 'decimal', pl: 2 }}>
            <ListItem sx={{ display: 'list-item', py: 0.5 }}>
              <ListItemText primary="Email us from your registered BacchaPanti account address." />
            </ListItem>
            <ListItem sx={{ display: 'list-item', py: 0.5 }}>
              <ListItemText primary='Use the subject line: "BacchaPanti account deletion request".' />
            </ListItem>
            <ListItem sx={{ display: 'list-item', py: 0.5 }}>
              <ListItemText primary="Include your full name and the email address tied to your account." />
            </ListItem>
          </List>

          <Button
            variant="contained"
            href={mailto}
            sx={{ mt: 2, mb: 3 }}
          >
            Email {SUPPORT_EMAIL}
          </Button>

          <Typography variant="h6" fontWeight={600} gutterBottom>
            What we delete
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            When your request is approved, we delete or anonymise account data linked to your
            profile, including your login credentials and personal contact details stored in
            BacchaPanti systems. Operational records required for legal, billing, or audit
            purposes may be retained as described in our privacy policy.
          </Typography>

          <Typography variant="h6" fontWeight={600} gutterBottom>
            Processing time
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            We aim to complete verified requests within 30 days. You may receive a confirmation
            email when deletion is finished.
          </Typography>

          <Typography variant="h6" fontWeight={600} gutterBottom>
            Staff and organisation accounts
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            If your account was created by your organisation administrator, you may also contact
            your BacchaPanti admin to deactivate access. Deletion requests from the registered
            email address are still honoured.
          </Typography>

          <Typography variant="h6" fontWeight={600} gutterBottom>
            Mobile app data on your device
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            After your account is deleted on our servers, sign out of the BacchaPanti mobile app
            or uninstall it to remove locally stored session tokens from your device.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="body2" color="text.secondary">
            Questions? Contact{' '}
            <Box component="a" href={`mailto:${SUPPORT_EMAIL}`} sx={{ color: 'primary.main' }}>
              {SUPPORT_EMAIL}
            </Box>
            . Web portal:{' '}
            <Box
              component="a"
              href="https://crm.bacchapanti.com"
              sx={{ color: 'primary.main' }}
            >
              crm.bacchapanti.com
            </Box>
          </Typography>

          <Box sx={{ mt: 3 }}>
            <Link to="/login" style={{ textDecoration: 'none' }}>
              Back to login
            </Link>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccountDeletion;
